import PropTypes from 'prop-types';

import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Text } from '@/design-system/atoms/Text';

import styles from './ArticleIntro.module.scss';

const ArticleIntro = ({ text, ...props }) => {
    return (
        <ContentContainer>
            <div className={styles[`article-intro`]} {...props}>
                <Text content={text} variant={Text.VARIANT.T1B} tag={Text.TAG.P} />
            </div>
        </ContentContainer>
    );
};

ArticleIntro.propTypes = {
    /**
     * The Article Intro content
     */
    text: PropTypes.string,
};

export default ArticleIntro;
